var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { cssColorValue, IconChevronLeft, Text, } from '@spotify-internal/encore-web/core';
import { AnimatePresence, m } from 'framer-motion';
import React from 'react';
import styled, { css } from 'styled-components';
import { HomeLink } from '../../../../HomeLink/HomeLink';
import { useS4XMastheadContext } from '../../../../S4XMastheadProvider';
import { NavBarHeightSmScreen, NavBarZIndex, SideFlyoutTopBarZIndex, } from '../../../constants';
import { flyoutTransitionOut, SECONDS_IN, SECONDS_OUT, } from '../FlyoutMenu/config';
import { MenuButton } from './MenuButton';
import { SiteLogoWrapper } from '../../../SiteLogoWrapper';
var openHomeLogoVariants = {
    initial: {
        x: '-100%'
    },
    animate: {
        x: 0,
        zIndex: SideFlyoutTopBarZIndex
    },
    exit: {
        x: '-100%'
    }
};
var backButtonVariants = {
    initial: {
        x: '100%'
    },
    animate: {
        x: 0,
        zIndex: SideFlyoutTopBarZIndex
    },
    exit: {
        x: '150%'
    }
};
var SubMenuBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  position: fixed;\n  width: 100vw;\n  height: ", "px;\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  position: fixed;\n  width: 100vw;\n  height: ", "px;\n  overflow: hidden;\n"])), cssColorValue('backgroundBase'), NavBarHeightSmScreen);
var SubMenuTitleWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  // take up 100% of the header space minus the back button\n  // to center properly\n  width: calc(100% - 24px);\n  justify-content: center;\n  z-index: ", ";\n"], ["\n  display: flex;\n  // take up 100% of the header space minus the back button\n  // to center properly\n  width: calc(100% - 24px);\n  justify-content: center;\n  z-index: ", ";\n"])), NavBarZIndex);
var StyledLogo = styled(SiteLogoWrapper).withConfig({
    shouldForwardProp: function (prop) { return !['isMenuOpen'].includes(prop); }
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fill: ", ";\n  ", "\n  transition: all ", "s cubic-bezier(0.5, 0, 0, 1);\n"], ["\n  fill: ", ";\n  ", "\n  transition: all ", "s cubic-bezier(0.5, 0, 0, 1);\n"])), function (props) { return props.theme.text; }, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return isMenuOpen && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      fill: ", ";\n    "], ["\n      fill: ", ";\n    "])), cssColorValue('textBase'));
}, function (_a) {
    var isMenuOpen = _a.isMenuOpen;
    return isMenuOpen ? SECONDS_IN : SECONDS_OUT;
});
export var MenuHeader = function (_a) {
    var isMenuOpen = _a.isMenuOpen, onBack = _a.onBack, label = _a.label;
    var _b = useS4XMastheadContext(), mastheadData = _b.mastheadData, siteLogo = _b.siteLogo;
    var headerEntry = mastheadData === null || mastheadData === void 0 ? void 0 : mastheadData.fields.header;
    var key = !label ? 'back' : 'home';
    if (label) {
        return (React.createElement(AnimatePresence, { mode: "popLayout" },
            React.createElement(m.div, { key: key + new Date(), initial: "initial", animate: "animate", exit: "exit", variants: backButtonVariants, transition: flyoutTransitionOut, "data-testid": "back", style: {
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%',
                    width: '100%'
                } },
                React.createElement(SubMenuBackground, null),
                React.createElement(MenuButton, { size: "medium", color: cssColorValue('textBase'), "data-testid": "navigation-sidemenu-back", iconOnly: IconChevronLeft, tabIndex: 0, onKeyDown: onBack, onClick: onBack, "aria-label": label }),
                React.createElement(SubMenuTitleWrapper, null,
                    React.createElement(Text, { variant: "titleSmall" }, label)))));
    }
    return (React.createElement(AnimatePresence, { mode: "popLayout" },
        React.createElement(m.div, { key: key + new Date(), initial: "initial", animate: "animate", exit: "exit", variants: (label && openHomeLogoVariants), transition: flyoutTransitionOut, "data-testid": "home", style: {
                alignItems: 'center',
                display: 'flex',
                height: '100%',
                width: '100%'
            } },
            React.createElement(HomeLink, { label: headerEntry.fields.navBarLogoLabel, style: { zIndex: SideFlyoutTopBarZIndex } },
                React.createElement(StyledLogo, { isMenuOpen: isMenuOpen, component: siteLogo, label: headerEntry.fields.navBarLogoLabel, height: 28 })))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
